<template>
	<div class="update">
		<div class="left-menus">
			<div class="left-list">
				<div :class="enpId == item.id ? 'left-enp-item-active' : 'left-enp-item'" v-for="item in menusList" :key="item.id" @click="handleEnp(item.id)">
					<!-- <div :class="enpId == item.id ? 'enp-item-status-active' : 'enp-item-status'">{{item.id % 2 ? '后' : '预'}}</div> -->
					<div class="enp-item-name">{{item.name}}</div>
				</div>
			</div>
		</div>

		<div class="right-wrap wrap">
			<div class="new-box" v-if="enpId == 1">
				<div class="list-wrap">
					<div class="news-list" v-if="enpId == 1 && list.length > 0">
						<div class="new-item" v-for="item in list" :key="item.id" @click="handleLoadFind(item.id)">
							<div class="new-item-header">
								<div class="new-item-title">{{item.name}}</div>
								<div class="new-item-times">{{item.created_at}}</div>
							</div>
							<div class="qjc-flex new-item-bot">
								<div class="new-item-content">{{item.title}}</div>
								<div class="new-item-read" :class="item.is_read == '2' ? 'readed' : 'not-read'">{{ item.is_read == '1' ? '未读' : item.is_read == '2' ? '已读' : ''}}</div>
							</div>
						</div>
						<el-pagination
							class="pagination qjc-texta-c"
							layout="prev, pager, next"
							hide-on-single-page
							:current-page.sync="pager.page"
							:page-count="pager.pagecount"
							:page-size="pager.pagesize"
							:total="pager.count"
							@current-change="pageChange">
						</el-pagination>
					</div>
					<div class="no-data" :style="{ minHeight: mainHeight -190 + 'px' }" v-if="enpId == 1 && list.length <= 0">
						<div class="">
							<el-image class="empty-img" :src="require('@/assets/images/empty-new.png')"></el-image>
							<div class="empty-text">暂无消息通知</div>
						</div>
					</div>
				</div>
				<div class="new-detail" v-if="JSON.stringify(newData) != '{}'">
					<div class="new-detail-header">
						<div class="new-detail-avatar">{{newData.from.substr(-2)}}</div>
						<div class="new-detail-header-info">
							<div class="qjc-flex new-detail-cell">
								<div class="new-detail-from">{{newData.from}}</div>
								<div class="new-detail-time">{{newData.created_at}}</div>
							</div>
							<div class="new-detail-to qjc-flex">
								<span class="new-detail-to-text">收件人：</span>
								<span class="new-detail-to-title">{{newData.to}}</span>
							</div>
							<div class="new-detail-theme">
								<div class="new-detail-theme-text">{{newData.title}}</div>
								<div class="new-detail-success">发送成功</div>
							</div>
						</div> 
					</div>
					<div class="new-detail-content">
						<div class="new-detail-content-text" v-html="newData.content"></div>
					</div>
				</div>
				<div class="new-detail-no" :style="{ minHeight: mainHeight -190+ 'px' }" v-if="JSON.stringify(newData) == '{}' && list.length > 0">
					<div class="new-detail-no-box">
						<el-image class="new-no-img" :src="require('@/assets/images/empty-new.png')"></el-image>
						<div class="new-no-title">暂未选择消息</div>
					</div>
				</div>
			</div>
			
			
			<div class="edit-wrap" :style="{minHeight: mainHeight-24+'px'}" v-if="enpId == 0">
				<div class="addressee">
					<span class="addressee-title">收件人</span>
					<div class="addressee-list">
						<span class="" v-for="item in checkedCities" :key="item" >{{item}},</span>
					</div>
					<div class=" add-text">
						<span class="addressee-add" @click="handleAddNews">+</span>
					</div>
				</div>
				<div class="theme">
					<span class="theme-title">主   题</span>
					<el-input class="theme-input" v-model="themeValue" placeholder="请输入主题内容"></el-input>
				</div>
				<div class="editor-wrap">
					<tinymce-editor id="mytinymce" ref="editor" :tinyvalue="contentInfo" v-model="editorValue" @tinymceinput="tinymceinput"></tinymce-editor>
				</div>
				<div class="foot-btn">
					<el-button class="submit-btn" @click="handleAdd">发送</el-button>
				</div>
			</div>
		</div>
		
		<el-dialog :visible.sync="isAddShow" :show-close="false" :close-on-click-modal="false" width="560px">
			<div class="add-wrap">
				<div class="add-left">
					<el-autocomplete
					      class="inline-input"
					      v-model="state1"
					      :fetch-suggestions="querySearch"
					      placeholder="搜索企业账号"
					      @select="handleSelect"
					    ></el-autocomplete>
					<div class="add-left-tags">
						<el-tag
						  v-for="tag in checkedCities"
						  :key="tag"
						   class="tag-item"
						   @close="handleClose(tag)"
						  closable>
						  {{tag}}
						</el-tag>
						<!-- <div class="">搜索企业账号</div> -->
					</div>
					<div class="add-left-foot">
						<el-button class="submit-btn" @click="handleSubmit">确认</el-button>
						<el-button class="cancel-btn" @click="handleCancel">取消</el-button>
					</div>
				</div>
				<div class="add-right">
					<div class="add-right-title">企业账号</div>
					<div class="add-right-list">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
							<el-checkbox class="add-check" v-for="city in companyList" :label="city.name" :key="city.id">
								<span class="add-check-tag">{{city.name.substr(-2)}}</span>
								<span>{{city.name}}</span>
							</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	import { Base64 } from "js-base64";
import tinymceEditor from "@/components/tinymceEditor";
	import { enterpriseList, messageNews } from '@/utils/axios.js'
export default {
	name: 'mainInfoNews',
	components:{
		tinymceEditor
	},
	data() {
		return {
			mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
			list: [],
			checkAll: false,
			checkedCities: [],
			cities: [],
			isIndeterminate: true,
			menusList: [
				{
					id: 0,
					icon: '',
					name: '编辑消息',
				},
				{
					id: 1,
					icon: '',
					name: '已发送',
				}
			],
			enpId: 0,
			editorValue: '',
			contentInfo: '',
			themeValue: '',
			isAddShow: false,
			restaurants: [],
			state1: '',
			companyList: [],
			pager: {
				count: 0,
				page: 1,// 默认第一页
				pagecount: 0,
				pagesize: 8//默认一页15条数据
			},
			newData: {},
		};
	},

	mounted() {
		window.onresize = () => {
			return (() => {
				this.mainHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60
			})();
		};
	},
	watch: {
		checkedCities(newVal){
			let checkedCount = newVal.length
			this.checkAll = checkedCount === this.companyList.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.companyList.length;
		},
		editorValue(newVal) {
		}
	},
	methods: {
		handleLoadFind(id) {
			messageNews({act: 'query', id: id}).then((res) => {
				if(res.code == 200) {
					let data = JSON.parse(window.atob(res.data))
					this.newData = data
				} else {
					this.$myAlert({
						type: 'fail',
						title: res.msg
					});
				}
			})
		},
		handleSelect(val) {
			if(this.checkedCities.length > 0) {
				if(this.checkedCities.indexOf(val.value) == -1) {
					this.checkedCities.push(val.value)
				}
				return
			} 
			this.checkedCities.push(val.value)
		},
		querySearch(queryString, cb) {
			var restaurants = this.restaurants;
			var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
			// 调用 callback 返回建议列表的数据
			cb(results);
		},
		createFilter(queryString) {
			return (restaurant) => {
			  return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			};
		},
		loadAll() {
			let list = []
			this.companyList.map((item) => {
				let obj = {
					value: item.name,
					id: item.id
				}
				list.push(obj)
			})
			return list;
		},
		handleEnp(id) {
			this.enpId = id
			this.pager.page = 1
			if(this.enpId == 1) {
				this.handleLoadList()
			}
		},
		
		handleLoadList() {
			messageNews({
				page: this.pager.page,
				pagesize: this.pager.pagesize
			}).then((res) => {
				if(res.code == 200) {
					this.list = res.data.data
					
					var pager = res.data.pager;
					for(var key in pager){
						pager[key] = parseInt(pager[key]);
					}
					this.pager = pager;
				}
			})
		},
		
		tinymceinput(e) {
			let num = 0,
				reg = /<p>(&nbsp;|&nbsp;\s+)+<\/p>|<p>(<br>)+<\/p>/g;
				while(e != '' && num < e.length) {
					num++
					let k = e.match(reg)
					if(k) {
						e = e.replace(k[0], '')
					}
				}
			this.contentInfo = e
		},
		
		handleAddNews() {
			enterpriseList({act: ''}).then((res) => {
				if(res.code == 200){
					const  result = JSON.parse(Base64.decode(res.data))
					this.companyList = result;
					this.restaurants = this.loadAll();
				}else{
					this.$myAlert({
						type: 'fail',
						title: res.msg
					});
				}
			})
			this.isAddShow = true
		},
		handleAdd() {
			let list = [];
			this.checkedCities.map((item) => {
				this.companyList.map((val) => {
					if(item == val.name) {
						list.push(val.id)
					}
				})
				
			})
			if(list.length <= 0) {
				this.$myAlert({
					type: 'fail',
					title: '请添加收件人'
				});
				return
			}
			if(this.contentInfo.trim() == '') {
				this.$myAlert({
					type: 'fail',
					title: '请输入消息内容'
				});
				return
			}
			if(this.themeValue.trim() == '') {
				this.$myAlert({
					type: 'fail',
					title: '请输入消息主题'
				});
				return
			}
			messageNews({
				act: 'add',
				ids: list,
				title: this.themeValue,
				content: this.contentInfo,
				operator: localStorage.getItem('mobile'),
			}).then((res) => {
				if(res.code == 200) {
					this.$myAlert({
						type: 'success',
						title: res.msg
					});
					this.handleLoadList()
					this.enpId = 1
				}
			})
		},
		handleCancel() {
			this.isAddShow = false
		},
		
		handleSubmit() {
			this.isAddShow = false
		},
		
		handleCheckAllChange(val) {
			if(val) {
				this.companyList.map((item) => {
					if(this.checkedCities.indexOf(item.name) == -1) {
						this.checkedCities.push(item.name)
					}
				})
			} else {
				this.checkedCities = []
			}
			
			this.isIndeterminate = false;
		},
		
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.companyList.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.companyList.length;
		},
		handleClose(tag) {
			this.checkedCities.splice(this.checkedCities.indexOf(tag), 1);
		},
		pageChange(page) {
			this.pager.page = page;
			this.handleLoadList();
		},
	}
};
</script>

<style scoped>

	.editor-wrap >>> .tox-tinymce {
		height: 600px !important;
	}
	
	.theme >>> .el-input__inner {
		border: none;
	}
	
	.update >>> .el-dialog__header {
		padding: 0;
	}
	
	.update >>> .el-dialog__body {
		padding: 0;
	}
.update >>> .tox .tox-menubar {
	background-color: #f3f4fc;
}
.update >>> .tox .tox-mbtn {
	color: #666;
}
.update >>> .tox .tox-tbtn {
	color: #666;
}
.update >>> .tox .tox-tbtn:hover {
	background: #ccc;
}
.update >>> .tox .tox-tbtn svg {
	fill: #666;
}
.update >>> .tox .tox-toolbar, .update >>> .tox .tox-toolbar__overflow, .update >>> .tox .tox-toolbar__primary {
	background-color: #f3f4fc;
	height: 40px;
	position: relative;
	border-bottom: 1px solid #aaa;
}
.update >>> .tox .tox-tbtn--disabled, .update >>>.tox .tox-tbtn--disabled:hover, .update >>> .tox .tox-tbtn:disabled, .update >>> .tox .tox-tbtn:disabled:hover {
	color: #666;
}
.update >>> .tox .tox-statusbar {
	background-color: #f3f4fc;
	color: #666;
	border-color: #aaa;
}
.update >>> .tox .tox-statusbar a,.update >>>  .tox .tox-statusbar__path-item,.update >>>  .tox .tox-statusbar__wordcount {
	color: #666;
}
.update >>> .tox-tinymce {
	border-color: #aaa;
}
.update >>> .tox .tox-menubar+.tox-toolbar,.update >>>  .tox .tox-menubar+.tox-toolbar-overlord .tox-toolbar__primary {
	border-color: #aaa;
}
.update >>> .tox .tox-sidebar {
	border-color: #aaa;
}
.update >>> .tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
	border-color: #aaa;
}
.update >>> .el-tag .el-tag__close {
	color: #525866;
}
.update >>> .el-tag .el-tag__close:hover {
	background-color: #cccccc;
}
.update >>> .el-checkbox {
	font-weight: 400;
}
</style>
<style lang="scss" scoped>
	.update {
		display: flex;
		// padding: 24px;
		width: 100%;
		height: 100%;
		// border: 12px solid #F2F4FA;
		
		.add-left-foot {
			position: absolute;
			bottom: 20px;
			left: 30px;
		}
		
		.cancel-btn {
			width: 94px;
			height: 34px;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			border: 1px solid #6883FB;
			border-radius: 17px;
			background-color: #fff;
		}
		.submit-btn {
			width: 94px;
			height: 34px;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
			border: none;
			border-radius: 17px;
			background-color: #6883FB;
		}
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}
			
			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #7A8599;
				background-color: #E8E9EC;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
			
			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			
			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #E9EDFF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}
		
		.right-wrap {
			flex: 1;
			height: 99%;
			padding-right: 24px;
			// padding: 28px 24px;
			.list-wrap {
				width: 524px;
				height: 100%;
				padding: 24px;
				overflow-y: auto;
				border-right: 1px solid #E5E8F5;
			}
			
			.news-list {
				height: 100%;
				// overflow-y: auto;	
			}
			.new-item {
				padding-bottom: 16px;
				margin-bottom: 24px;
				border-bottom: 1px solid #E5E8F5;
				cursor: pointer;
				.new-item-header {
					display: flex;
					align-items: center;
					justify-content: space-between;
					
					.new-item-title {
						font-size: 15px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #525866;
					}
					
					.new-item-times {
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #AEB0BB;
					}
				}
				
				.new-item-content {
					// width: 100%;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #525866;
					line-height: 18px;
					margin-top: 8px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.new-item-bot {
					justify-content: space-between;
				}
				
				.new-item-read {
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #7A8599;
				}
				.readed {
					position: relative;
					padding: 10px;
					&::before {
						position: absolute;
						top: 16px;
						left: 0px;
						content: '';
						width: 6px;
						height: 6px;
						background: #E5E8F5;
						border-radius: 50%;
					}
				}
				.not-read {
					position: relative;
					padding: 10px;
					&::before {
						position: absolute;
						top: 16px;
						left: 0px;
						content: '';
						width: 6px;
						height: 6px;
						background: #FF5219;
						border-radius: 50%;
					}
				}
			}
			
			.edit-wrap {
				overflow-y: auto;
				.addressee {
					display: flex;
					align-items: center;
					padding: 11px 24px;
					margin-top: 10px;
					border-bottom: 1px solid #E5E8F5;
					
					span{
						margin-right: 10px;
					}
					.addressee-title {
						width: 60px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #525866;
					}
					.addressee-add {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 24px;
						height: 24px;
						font-size: 18px;
						padding-bottom: 4px;
						color: #6883FB;
						background-color: #fff;
						border: 1px solid #6883FB;
						border-radius: 50%;
						cursor: pointer;
					}
				}
				.theme {
					display: flex;
					align-items: center;
					padding: 11px 24px;
					margin-top: 10px;
					border-bottom: 1px solid #E5E8F5;
					.theme-title {
						width: 60px;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #525866;
						letter-spacing: 4px;
					}
					.theme-input {
						border: none;
					}
					
					
				}
				
				.foot-btn {
					text-align: center;
					margin-top: 40px;
				}
				
				.submit-btn {
					width: 96px;
					height: 32px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
					background: #6883FB;
					border-radius: 16px;
					border: none;
				}
				
				.el-button:active {
					background-color: #5B73DC;
				}
			}
		}
		.add-wrap {
			display: flex;
		}
		
		.add-left {
			position: relative;
			width: 302px;
			padding: 20px 30px;
			border-right: 1px solid #E5E8F5;
			
			.add-left-tags {
				display: flex;
				// align-items: center;
				flex-direction: row;
				flex-wrap: wrap;
				margin-top: 10px;
				// height: 340px;
				// overflow-y: auto;
				
				.tag-item {
					margin-right: 10px;
					margin-bottom: 10px;
					color: #525866;
					background-color: #F2F4FA;
					border-color: #F2F4FA;
					
					
				}
			}
		}
		
		.add-right {
			flex: 1;
			padding: 24px;
			min-height: 466px;
			max-height: 500px;
			overflow-y: auto;
			
			.add-right-title {
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #293033;
				line-height: 24px;
				margin-bottom: 20px;
			}
		}
		
		.add-check {
			display: block;
			margin-top: 22px;
		}
		
		.add-check-tag {
			display: inline-block;
			width: 28px;
			height: 28px;
			line-height: 28px;
			font-size: 12px;
			text-align: center;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			background-color: #6883FB;
			border-radius: 4px;
			margin-right: 8px;
		}
	}
	.no-data{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.empty-img {
		width: 282px;
		line-height: 264px;
	}
	.empty-text {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		text-align: center;
		margin-top: 20px;
	}
	.new-box {
		display: flex;
		height: 100%;
	}
	
	.new-detail {
		flex: 1;
		min-width: 526px;
		padding: 24px;
		
		.new-detail-header {
			display: flex;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			
			.new-detail-avatar {
				width: 40px;
				height: 40px;
				line-height: 40px;
				border-radius: 50%;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				text-align: center;
				background-color: #ECEFFF;
				margin-right: 8px;
			}
			
			.new-detail-header-info {
				flex: 1;
				.new-detail-cell {
					justify-content: space-between;
				}
				.new-detail-from {
					font-size: 15px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #525866
				}
				.new-detail-time {
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #7A8599;
				}
				
				.new-detail-to {
					align-items: center;
					margin-top: 8px;
				}
				
				.new-detail-to-text {
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #AEB0BB;
				}
				
				.new-detail-to-title {
					padding: 4px 8px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #525866;
					background: #E5E8FF;
					border-radius: 2px;
				}
				
				.new-detail-theme {
					margin-top: 21px;
				}
				
				.new-detail-theme-text {
					font-size: 15px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #525866;
				}
				.new-detail-success {
					width: 64px;
					height: 24px;
					line-height: 24px;
					font-size: 12px;
					text-align: center;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #44D061;
					background: #D9F7DF;
					border-radius: 2px;
					margin-top: 4px;
				}
			}
		}
		.new-detail-content {
			margin-top: 22px;
			
			.new-detail-content-text {
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;	
			}
		
		}
	}
	.new-detail-no {
		flex: 1;
		// height: 100%;
		min-width: 526px;
		margin-top: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.new-detail-no-box {
		// height: 100%;
	}
	.new-no-title {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		text-align: center;
		margin-top: 20px;
	}
	.new-no-img {
		width: 281px;
		height: 266px;
	}
</style>
